import React, {
  createContext,
  ReactNode,
  useState,
  ReactNode as RN,
} from 'react';
import {
  ConfirmModal,
  ConfirmModalProps,
} from '@/components/common/confirmationModal';

type showModalArgs = {
  message?: RN;
  onConfirmHandler: () => void;
  header?: string;
  subMessage?: RN;
  cancelButtonText?: string;
  confirmButtonText?: string;
  primaryCta?: 'cancel' | 'confirm',
  showCloseButton?: boolean;
  warning?: string;
  cancelButtonClassName?: string,
  confirmButtonClassName ?: string,
};
export type ConfirmModalContextType = {
  showModal: (args: showModalArgs) => void;
};
const ConfirmModalContext = createContext<ConfirmModalContextType>({
  showModal: () => {},
});
const Provider = ConfirmModalContext.Provider;

export const ConfirmationModalProvider: React.FC<{children: ReactNode}> = ({
  children,
}) => {
  const [modalData, setModalData] = useState<Omit<
    ConfirmModalProps,
    'onClose' | 'open'
  > | null>(null);

  const defaultCancelText = 'No';
  const defaultConfirmText = 'Yes';

  function showModal({
    message,
    subMessage,
    onConfirmHandler,
    showCloseButton,
    primaryCta = 'cancel',
    cancelButtonText = defaultCancelText,
    confirmButtonText = defaultConfirmText,
    header = '',
    warning= '',
    cancelButtonClassName,
    confirmButtonClassName,
  }: showModalArgs) {
    setModalData(p => ({
      header,
      message,
      subMessage,
      cancelButtonText,
      confirmButtonText,
      onConfirm: onConfirmHandler,
      primaryCta,
      showCloseIcon: showCloseButton,
      warning,
      cancelButtonClassName,
      confirmButtonClassName,
    }));
  }

  function handleClose() {
    setModalData(null);
  }

  return (
    <Provider
      value={{
        showModal,
      }}>
      {children}
      {modalData && (
        <ConfirmModal
          open={Boolean(modalData)}
          header={modalData?.header}
          message={modalData?.message}
          subMessage={modalData?.subMessage}
          onClose={handleClose}
          onConfirm={modalData?.onConfirm}
          cancelButtonText={modalData?.cancelButtonText}
          confirmButtonText={modalData?.confirmButtonText}
          primaryCta={modalData?.primaryCta}
          showCloseIcon={modalData.showCloseIcon}
          warning={modalData.warning}
          cancelButtonClassName={modalData.cancelButtonClassName}
          confirmButtonClassName={modalData.cancelButtonClassName}
        />
      )}
    </Provider>
  );
};

export default ConfirmModalContext;
